import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import {
  canActivate,
  redirectUnauthorizedTo,
  redirectLoggedInTo,
} from '@angular/fire/auth-guard';

import { map } from 'rxjs/operators';
import { AuthPipe } from '@angular/fire/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

const redirectAuthorizedToHome = () => {
  let age = JSON.parse(localStorage.getItem("age"));
  let currentRoute = window.location.href.split('/').splice(3, window.location.href.split('/')?.length - 1).join('/');
  let club_registeration_link = window.location.href.split('/').splice(3, window.location.href.split('/')?.length - 1).join('/');
  let app_first_route = window.location.href.split('/');

  if (currentRoute != '') {
    if (!age && app_first_route[4] == 'registration-club') {
      localStorage.setItem("club_registeration_link", club_registeration_link)
    }
    return redirectLoggedInTo([currentRoute]);
  } else {
    return redirectLoggedInTo(['home']);
  }
};

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./views/auth/auth.module').then( m => m.AuthPageModule),
    canActivate: [redirectAuthorizedToHome]
  },
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module').then( m => m.HomePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'panda/:home',
    loadChildren: () => import('./views/home/home.module').then( m => m.HomePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'profile/:id',
    loadChildren: () => import('./views/profile/profile.module').then( m => m.ProfilePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'undefined',
    loadChildren: () => import('./views/profile/profile.module').then( m => m.ProfilePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'settings',
    loadChildren: () => import('./views/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'teaming-up',
    loadChildren: () => import('./views/teaming-up/teaming-up.module').then( m => m.TeamingUpPageModule),
  },
  {
    path: 'league-info',
    loadChildren: () => import('./views/teaming-up/teaming-up.module').then( m => m.TeamingUpPageModule),
  },
  {
    path: 'calendar',
    loadChildren: () => import('./views/calendar/calendar.module').then( m => m.CalendarPageModule)
  },
  {
    path: 'panda-connect',
    loadChildren: () => import('./views/panda-connect/panda-connect.module').then( m => m.PandaConnectPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./views/chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'email-coach',
    loadChildren: () => import('./views/email-coach/email-coach.module').then( m => m.EmailCoachPageModule)
  },
  {
    path: 'workouts',
    loadChildren: () => import('./views/workouts/workouts.module').then( m => m.WorkoutsPageModule)
  },
  {
    path: 'comparison',
    loadChildren: () => import('./views/comparison/comparison.module').then( m => m.ComparisonPageModule)
  },
  {
    path: 'quick-workout',
    loadChildren: () => import('./views/quick-workout/quick-workout.module').then( m => m.QuickWorkoutPageModule)
  },
  {
    path: 'challenge',
    loadChildren: () => import('./views/challenge/challenge.module').then( m => m.ChallengePageModule)
  },
  {
    path: 'aci-comparison',
    loadChildren: () => import('./views/aci-comparison/aci-comparison.module').then( m => m.AciComparisonPageModule)
  },
  {
    path: 'panda-club',
    loadChildren: () => import('./views/panda-club/panda-club.module').then( m => m.PandaClubPageModule)
  },
  {
    path: 'reverse-lookups',
    loadChildren: () => import('./views/reverse-lookups/reverse-lookups.module').then( m => m.ReverseLookupsPageModule)
  },
  {
    path: 'new-quick-workout',
    loadChildren: () => import('./components/new-quick-workout/new-quick-workout.module').then( m => m.NewQuickWorkoutPageModule)
  },
  {
    path: 'new-field-events',
    loadChildren: () => import('./views/my-schedules/new-field-events/new-field-events.module').then( m => m.NewFieldEventsPageModule)
  },
  {
    path: 'my-schedules',
    loadChildren: () => import('./views/my-schedules/my-schedules.module').then( m => m.MySchedulesPageModule)
  },
  {
    path: 'field-facility',
    loadChildren: () => import('./views/field-facility/field-facility.module').then( m => m.FieldFacilityPageModule)
  },
  {
    path: 'ad-contacts',
    loadChildren: () => import('./views/ad-contacts/ad-contacts.module').then( m => m.AdContactsPageModule)
  },
  {
    path: 'referee-contacts',
    loadChildren: () => import('./views/referee-contacts/referee-contacts.module').then( m => m.RefereeContactsPageModule)
  },
  {
    path: 'bus-contacts',
    loadChildren: () => import('./views/bus-contacts/bus-contacts.module').then( m => m.BusContactsPageModule)
  },
  {
    path: 'event-staff',
    loadChildren: () => import('./views/event-staff/event-staff.module').then( m => m.EventStaffPageModule)
  },
  {
    path: 'field-schedule-report',
    loadChildren: () => import('./views/field-schedule-report/field-schedule-report.module').then( m => m.FieldScheduleReportPageModule)
  },
  {
    path: 'field-activity-map',
    loadChildren: () => import('./views/field-activity-map/field-activity-map.module').then( m => m.FieldActivityMapPageModule)
  },
  {
    path: 'game-contract/:event_id',
    loadChildren: () => import('./views/game-contract/game-contract.module').then( m => m.GameContractPageModule)
  },
  {
    path: 'assigned-referee-contract/:event_id/:assigned_id',
    loadChildren: () => import('./views/assigned-referee-contract/assigned-referee-contract.module').then( m => m.AssignedRefereeContractPageModule)
  },
  {
    path: 'referee-contract/:event_id/:referee_id/:refs_needed',
    loadChildren: () => import('./views/referee-contract/referee-contract.module').then( m => m.RefereeContractPageModule)
  },
  {
    path: 'bus-service-contract/:event_id',
    loadChildren: () => import('./views/bus-service-contract/bus-service-contract.module').then( m => m.BusServiceContractPageModule)
  },
  {
    path: 'bus-service-contract/:event_id/:bus_id',
    loadChildren: () => import('./views/bus-service-contract/bus-service-contract.module').then( m => m.BusServiceContractPageModule)
  },
  {
    path: 'event-staff-contract/:event_id/:staff_id',
    loadChildren: () => import('./views/event-staff-contract/event-staff-contract.module').then( m => m.EventStaffContractPageModule)
  },
 {
    path: 'public-profile/:id',
    loadChildren: () => import('./views/public-profile/public-profile.module').then( m => m.PublicProfilePageModule)
  },
  {
    path: 'manage-admins',
    loadChildren: () => import('./views/manage-admins/manage-admins.module').then( m => m.ManageAdminsPageModule)
  },
  {
    path: 'leagues',
    loadChildren: () => import('./views/leagues/leagues.module').then( m => m.LeaguesPageModule)
  },
  {
    path: 'assigned-leagues',
    loadChildren: () => import('./views/assigned-leagues/assigned-leagues.module').then( m => m.AssignedLeaguesPageModule)
  },
  {
    path: 'panda-pay',
    loadChildren: () => import('./views/panda-pay/panda-pay.module').then( m => m.PandaPayPageModule)
  },
  {
    path: 'panda-pay-transactions',
    loadChildren: () => import('./views/panda-pay-transactions/panda-pay-transactions.module').then( m => m.PandaPayTransactionsPageModule)
  },
  {
    // Internal staff tool — the admin-wide transaction view, separate from the
    // user-facing 'panda-pay-transactions' wallet history above. The nav only
    // shows it to the 'ssadmin' role and the page itself refuses to render for
    // anyone else, but the real boundary is the API: every request re-checks
    // users.role server-side.
    path: 'panda-pay-admin-transactions',
    loadChildren: () => import('./views/panda-pay-admin-transactions/panda-pay-admin-transactions.module')
      .then( m => m.PandaPayAdminTransactionsPageModule)
  },
  {
    // Internal staff tool. The nav only shows it to the 'ssadmin' role and the
    // page itself refuses to render for anyone else, but the real boundary is
    // the API: every 1099-admin request re-checks users.role server-side.
    path: 'panda-1099-admin',
    loadChildren: () => import('./views/panda-1099-admin/panda-1099-admin.module').then( m => m.Panda1099AdminPageModule)
  },
  {
    // Internal staff tool: every club's registration payments and the
    // Panda/club split. The nav only shows it to 'ssadmin' and the page refuses
    // to render for anyone else, but the real boundary is the API: every
    // club?type=admin_* request re-checks users.role server-side.
    path: 'club-details-admin',
    loadChildren: () => import('./views/club-details-admin/club-details-admin.module').then( m => m.ClubDetailsAdminPageModule)
  },
  {
    // Internal staff tool: every user account, filterable by name/email, role
    // and status. The nav only shows it to 'ssadmin' and the page refuses to
    // render for anyone else, but the real boundary is the API:
    // user?type=admin_list_users re-checks users.role server-side.
    path: 'manage-users',
    loadChildren: () => import('./views/manage-users/manage-users.module').then( m => m.ManageUsersPageModule)
  },
  {
    path: 'website',
    loadChildren: () => import('./views/website/website.module').then( m => m.WebsitePageModule)
  },
  {
    // Internal staff tool. The nav only shows it to the 'admin' role and the
    // page itself refuses to render for anyone else, but the real boundary is
    // the API: every website-admin request re-checks users.role server-side.
    path: 'manage-websites',
    loadChildren: () => import('./views/manage-websites/manage-websites.module').then( m => m.ManageWebsitesPageModule)
   
  },
  { 
    path: 'form-1099',
    loadChildren: () => import('./views/form-1099/form-1099.module').then( m => m.Form1099PageModule)
  },
  {
    path: 'referee-calendar',
    loadChildren: () => import('./views/referee-calendar/referee-calendar.module').then( m => m.RefereeCalendarPageModule)
  },
  {
    path: 'referee-assign',
    loadChildren: () => import('./views/referee-assign/referee-assign.module').then( m => m.RefereeAssignPageModule)
  },
  {
    path: 'schedule-listing',
    loadChildren: () => import('./views/assigner/schedule-listing/schedule-listing.module').then( m => m.ScheduleListingPageModule)
  },
  { path: '**', redirectTo: 'home' },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
